export default __webpack_public_path__ + "static/media/about-5.d09fe0b7.png";